export const growFr = {
  "ft.powered": "Propulsé par Groupe MJR Construction Inc.",
  "rl.badge": "Parrain du mois",
  "rl.title": "Meilleurs parrains du mois",
  "rl.sub": "Classement selon le nombre d'amis inscrits et récompensés ce mois-ci. Le premier reçoit le badge « Parrain du mois ».",
  "rl.empty": "Personne encore ce mois-ci : invite un ami et prends la première place !",
  "rl.you": "toi",
  "rl.page_title": "Les parrains du mois",
  "rl.page_sub": "Chaque ami qui s'inscrit avec ton lien vous donne 3 clips bonus chacun. Le parrain n° 1 du mois affiche le badge doré sur son profil.",
  "rl.cta_user": "Copier mon lien de parrainage",
  "rl.cta_guest": "Créer mon compte gratuit",
  "rl.public_link": "Voir le classement public →",
  "rl.footer": "Parrains",
  "ex.auto_raw_hint": "Clips bruts : seulement le logo CLIP-EX, sans effet ni sous-titres. Ajoute ce que tu veux ensuite dans l'éditeur.",
  "sub.pos_custom": "Perso (souris)",
  "sub.size": "Taille",
  "mp.title": "Mes réglages favoris",
  "mp.save": "Enregistrer",
  "mp.saved": "Réglage enregistré dans tes favoris !",
  "mp.missing": "Cette musique n'est plus disponible. Supprime ce favori.",
  "tr.weekly_title": "Mon trailer chaque lundi par courriel",
  "tr.weekly_desc": "Le lundi à 9 h (heure de Montréal), l'IA monte tes 5 meilleurs clips de la semaine et t'envoie le lien, avec le texte prêt à publier. Il faut au moins 2 clips dans la semaine.",
  "tr.weekly_on": "Activé : ton trailer arrivera lundi à 9 h",
  "tr.weekly_off": "Trailer du lundi désactivé",
  "tr.weekly_badge": "LUNDI",
  "tr.live_badge": "BEST-OF LIVE",
  "tr.unsub_done": "C'est noté !",
  "tr.unsub_error": "Lien invalide",
  "tr.unsub_error_desc": "Ce lien de désabonnement est invalide. Tu peux désactiver le trailer du lundi dans Mes clips.",
  "tr.unsub_desc": "Tu ne recevras plus ton trailer du lundi. Tu peux le réactiver en tout temps dans Mes clips.",
  "tr.unsub_back": "Aller à Mes clips",
  "mp.applied": "Réglage « {n} » appliqué",
  "mp.name_ph": "Nom du réglage (ex. Phonk fort)",
  "mp.empty": "Choisis une musique, règle-la, puis clique « Enregistrer » pour la réutiliser en un clic (5 max).",
  "sub.drag_hint": "Mets la vidéo sur pause, glisse les sous-titres sur l'aperçu pour les placer, et tire le rond bleu pour changer leur taille.",
  "mu.cat_full60": "60 s complètes",
  "mu.fade_in": "Fondu début",
  "mu.fade_out": "Fondu fin",
  "mu.duck": "Baisser la musique quand tu parles",
  "mu.mode_drop": "Drop sur le moment fort",
  "mu.mode_passage": "Je choisis le passage",
  "mu.passage": "Passage de la chanson",
  "mu.passage_hint": "Glisse le cadre violet pour choisir le moment de la chanson.",
  "mu.passage_loop": "Ton clip est plus long que la chanson : elle repart en boucle.",
  "mu.listen": "Écouter",
  "mu.stop": "Stop",
  "mu.note": "Musiques originales créées par IA, libres de droits : aucun risque de blocage sur TikTok, Reels ou Shorts. La catégorie « 60 s complètes » couvre un clip entier sans boucle.",
  "ref.nav": "Parrainage",
  "ref.label": "Parrainage",
  "ref.t1": "Invite tes amis, ",
  "ref.t2": "gagnez tous les deux",
  "ref.sub": "Partage ton lien. Quand un ami s'inscrit, tu gagnes {a} clips bonus et lui aussi reçoit {b} clips bonus. Ces clips n'expirent jamais.",
  "ref.link": "Ton lien d'invitation",
  "ref.code": "Ton code",
  "ref.copy": "Copier",
  "ref.copied": "Lien copié !",
  "ref.share": "Partager",
  "ref.share_text": "Je clippe mes meilleurs moments de stream avec CLIP-EX. Inscris-toi avec mon lien et reçois {n} clips gratuits :",
  "ref.friends": "Amis inscrits",
  "ref.earned": "Clips gagnés",
  "ref.month": "Récompenses ce mois-ci",
  "ref.how": "Comment ça marche",
  "ref.step1": "Copie ton lien ou partage-le sur Discord, TikTok ou en message privé.",
  "ref.step2": "Ton ami crée son compte CLIP-EX avec ton lien.",
  "ref.step3": "Vous recevez tous les deux vos clips bonus tout de suite.",
  "ref.list": "Tes amis",
  "ref.none": "Personne encore. Partage ton lien pour commencer !",
  "ref.st_rewarded": "+{n} clips",
  "ref.st_capped": "Limite du mois atteinte",
  "ref.st_blocked": "Même connexion : non récompensé",
  "ref.st_signed_up": "Inscrit",
  "ref.rules": "Maximum {cap} amis récompensés par mois. Les comptes créés depuis la même connexion que toi ne sont pas récompensés.",
  "ref.invited_by": "{name} t'invite sur CLIP-EX",
  "ref.invited": "Tu as été invité sur CLIP-EX",
  "ref.banner_bonus": "Inscris-toi et reçois {n} clips bonus gratuits.",
  "ref.landing_sub": "L'IA trouve tes meilleurs moments de stream et les transforme en clips TikTok, Reels et Shorts en quelques secondes.",
  "ref.landing_cta": "Créer mon compte et recevoir mes clips",
  "ref.landing_bad": "Ce lien d'invitation n'est plus valide, mais tu peux quand même essayer CLIP-EX gratuitement.",
  "ref.welcome_bonus": "Bienvenue ! Tu as reçu {n} clips bonus grâce à ton invitation.",
  "cr.k_referral_welcome": "Bonus d'invitation",
  "tr.title": "Trailer des meilleurs moments",
  "tr.sub": "L'IA prend tes meilleurs clips de la période, écrit le titre et les étiquettes, puis monte un compte à rebours prêt à publier.",
  "tr.days": "{n} jours",
  "tr.found": "{n} clips sélectionnés",
  "tr.need": "Il te faut au moins 2 clips terminés sur cette période.",
  "tr.create": "Créer mon trailer",
  "tr.started": "Montage lancé ! Ton trailer sera prêt dans environ une minute.",
  "tr.rendering": "Montage en cours…",
  "tr.failed": "Le montage a échoué. Réessaie.",
  "tr.download": "Télécharger",
  "tr.copy_caption": "Copier le texte",
  "tr.caption_copied": "Texte copié !",
  "tr.copy_failed": "Impossible de copier. Sélectionne le texte à la main.",
  "tr.delete": "Supprimer",
  "tr.confirm_delete": "Supprimer ce trailer ?",
  "tr.limit": "Maximum 3 trailers par jour.",
};

export const growEn = {
  "ft.powered": "Powered by Groupe MJR Construction Inc.",
  "rl.badge": "Referrer of the month",
  "rl.title": "Top referrers of the month",
  "rl.sub": "Ranked by friends who signed up and were rewarded this month. Number one gets the “Referrer of the month” badge.",
  "rl.empty": "Nobody yet this month: invite a friend and take first place!",
  "rl.you": "you",
  "rl.page_title": "Referrers of the month",
  "rl.page_sub": "Every friend who signs up with your link gives you both 3 bonus clips. The #1 referrer of the month shows the golden badge on their profile.",
  "rl.cta_user": "Copy my referral link",
  "rl.cta_guest": "Create my free account",
  "rl.public_link": "See the public leaderboard →",
  "rl.footer": "Referrers",
  "ex.auto_raw_hint": "Raw clips: only the CLIP-EX logo, no effects or captions. Add whatever you want afterwards in the editor.",
  "sub.pos_custom": "Custom (mouse)",
  "sub.size": "Size",
  "mp.title": "My favourite settings",
  "mp.save": "Save",
  "mp.saved": "Setting saved to your favourites!",
  "mp.missing": "This track is no longer available. Delete this favourite.",
  "tr.weekly_title": "My trailer every Monday by email",
  "tr.weekly_desc": "On Mondays at 9 am (Montreal time), the AI edits your 5 best clips of the week and emails you the link, with a caption ready to post. You need at least 2 clips that week.",
  "tr.weekly_on": "On: your trailer arrives Monday at 9 am",
  "tr.weekly_off": "Monday trailer turned off",
  "tr.weekly_badge": "MONDAY",
  "tr.live_badge": "LIVE BEST-OF",
  "tr.unsub_done": "Done!",
  "tr.unsub_error": "Invalid link",
  "tr.unsub_error_desc": "This unsubscribe link is invalid. You can turn off the Monday trailer in My clips.",
  "tr.unsub_desc": "You won't get your Monday trailer anymore. You can turn it back on anytime in My clips.",
  "tr.unsub_back": "Go to My clips",
  "mp.applied": "Setting “{n}” applied",
  "mp.name_ph": "Setting name (e.g. Loud phonk)",
  "mp.empty": "Pick a track, tune it, then click “Save” to reuse it in one click (5 max).",
  "sub.drag_hint": "Pause the video, drag the captions on the preview to place them, and pull the blue dot to resize them.",
  "mu.cat_full60": "Full 60 s",
  "mu.fade_in": "Fade in",
  "mu.fade_out": "Fade out",
  "mu.duck": "Lower music when you talk",
  "mu.mode_drop": "Drop on the highlight",
  "mu.mode_passage": "I pick the part",
  "mu.passage": "Song section",
  "mu.passage_hint": "Drag the purple frame to pick the part of the song.",
  "mu.passage_loop": "Your clip is longer than the song: it loops.",
  "mu.listen": "Listen",
  "mu.stop": "Stop",
  "mu.note": "Original AI-made, royalty-free tracks: no risk of blocks on TikTok, Reels or Shorts. The “Full 60 s” category covers a whole clip without looping.",
  "ref.nav": "Referrals",
  "ref.label": "Referrals",
  "ref.t1": "Invite your friends, ",
  "ref.t2": "you both win",
  "ref.sub": "Share your link. When a friend signs up, you earn {a} bonus clips and they get {b} bonus clips too. These clips never expire.",
  "ref.link": "Your invite link",
  "ref.code": "Your code",
  "ref.copy": "Copy",
  "ref.copied": "Link copied!",
  "ref.share": "Share",
  "ref.share_text": "I clip my best stream moments with CLIP-EX. Sign up with my link and get {n} free clips:",
  "ref.friends": "Friends joined",
  "ref.earned": "Clips earned",
  "ref.month": "Rewards this month",
  "ref.how": "How it works",
  "ref.step1": "Copy your link or share it on Discord, TikTok or in a DM.",
  "ref.step2": "Your friend creates a CLIP-EX account with your link.",
  "ref.step3": "You both get your bonus clips right away.",
  "ref.list": "Your friends",
  "ref.none": "Nobody yet. Share your link to get started!",
  "ref.st_rewarded": "+{n} clips",
  "ref.st_capped": "Monthly limit reached",
  "ref.st_blocked": "Same connection: not rewarded",
  "ref.st_signed_up": "Joined",
  "ref.rules": "Up to {cap} rewarded friends per month. Accounts created from the same connection as yours are not rewarded.",
  "ref.invited_by": "{name} invites you to CLIP-EX",
  "ref.invited": "You've been invited to CLIP-EX",
  "ref.banner_bonus": "Sign up and get {n} free bonus clips.",
  "ref.landing_sub": "AI finds your best stream moments and turns them into TikTok, Reels and Shorts clips in seconds.",
  "ref.landing_cta": "Create my account and get my clips",
  "ref.landing_bad": "This invite link is no longer valid, but you can still try CLIP-EX for free.",
  "ref.welcome_bonus": "Welcome! You got {n} bonus clips from your invite.",
  "cr.k_referral_welcome": "Invite bonus",
  "tr.title": "Best moments trailer",
  "tr.sub": "AI takes your best clips from the period, writes the title and labels, then edits a countdown ready to post.",
  "tr.days": "{n} days",
  "tr.found": "{n} clips selected",
  "tr.need": "You need at least 2 finished clips in this period.",
  "tr.create": "Create my trailer",
  "tr.started": "Editing started! Your trailer will be ready in about a minute.",
  "tr.rendering": "Editing…",
  "tr.failed": "Editing failed. Try again.",
  "tr.download": "Download",
  "tr.copy_caption": "Copy caption",
  "tr.caption_copied": "Caption copied!",
  "tr.copy_failed": "Couldn't copy. Select the text manually.",
  "tr.delete": "Delete",
  "tr.confirm_delete": "Delete this trailer?",
  "tr.limit": "Up to 3 trailers per day.",
};
